<script setup lang="ts">
import { type PropType } from 'vue'
type SpinnerSize = 'sm' | 'md' | 'lg'
type SpinnerLabelPosition = 'bottom' | 'right'

const props = defineProps({
  size: {
    type: String as PropType<SpinnerSize>,
    default: 'md',
  },
  label: {
    type: String,
    default: undefined,
  },
  position: {
    type: String as PropType<SpinnerLabelPosition>,
    default: 'bottom',
  },
  dataTest: {
    type: String,
    default: '',
  },
})
</script>

<template>
  <PuikSpinnerLoader v-bind="props" />
</template>
